// src/App.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Root entry point — manages auth state and routes between screens.
// Replace the useState("login") default with session/token logic for production.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from "react";
import LoginScreen  from "./screens/LoginScreen";
import SignupScreen from "./screens/SignupScreen";
import PortalShell  from "./screens/PortalShell";

export default function App() {
  // Possible values: "login" | "signup" | "portal"
  const [screen, setScreen] = useState("login");

  if (screen === "login") {
    return (
      <LoginScreen
        onLogin={()  => setScreen("portal")}
        onSignup={() => setScreen("signup")}
      />
    );
  }

  if (screen === "signup") {
    return (
      <SignupScreen
        onLogin={() => setScreen("login")}
        onBack={()  => setScreen("login")}
      />
    );
  }

  return (
    <PortalShell
      onLogout={() => setScreen("login")}
    />
  );
}